module.exports = __webpack_public_path__ + "img/cover_kim_1200x1600.76db8c89.jpg";